
import { useState } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface PropertyDescriptionProps {
  description: string;
}

const PropertyDescription = ({ description }: PropertyDescriptionProps) => {
  const isMobile = useIsMobile();
  const [showFullDescription, setShowFullDescription] = useState(false);

  // Split description by \n\n to create paragraphs for better formatting
  const paragraphs = description.split('\n\n');

  // For mobile truncation logic
  const shouldTruncate = isMobile && description.length > 400;
  const truncatedText = shouldTruncate ? description.substring(0, 400) : description;

  return (
    <div className="py-6 border-b border-gray-200">
      <h3 className="text-xl font-semibold mb-6">Descripción</h3>
      <div className="space-y-4">
        {isMobile ? (
          // Mobile view with truncation
          <div>
            {showFullDescription ? (
              // Show full description with paragraphs
              paragraphs.map((paragraph, index) => (
                <p key={index} className="text-gray-700 leading-relaxed mb-4 last:mb-0">
                  {paragraph}
                </p>
              ))
            ) : (
              // Show truncated text
              <p className="text-gray-700 leading-relaxed">
                {truncatedText}
                {shouldTruncate && '...'}
              </p>
            )}
            
            {shouldTruncate && (
              <button
                onClick={() => setShowFullDescription(!showFullDescription)}
                className="mt-2 text-gray-900 font-medium underline hover:no-underline transition-all"
              >
                {showFullDescription ? 'Mostrar menos' : 'Mostrar más'}
              </button>
            )}
          </div>
        ) : (
          // Desktop view - always show full description with paragraphs
          paragraphs.map((paragraph, index) => (
            <p key={index} className="text-gray-700 leading-relaxed">
              {paragraph}
            </p>
          ))
        )}
      </div>
    </div>
  );
};

export default PropertyDescription;
